import type { ChatMessage, ChatSession, ChatSessionKind } from "@/types";
import { apiClient } from "./client";

export const chatSessionService = {
  /** Sessions (visitor + guest) with at least one message, newest activity first. */
  list: async (propertyId: string): Promise<ChatSession[]> => {
    const { data } = await apiClient.get<ChatSession[]>("/admin/chat-sessions", {
      params: { property_id: propertyId },
    });
    return data;
  },

  /** Admin read-only transcript of one session. */
  messages: async (kind: ChatSessionKind, sessionId: string): Promise<ChatMessage[]> => {
    const { data } = await apiClient.get<ChatMessage[]>("/admin/messages", {
      params: kind === "guest" ? { guest_id: sessionId } : { visitor_id: sessionId },
    });
    return data;
  },
};
